import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AdmissionOfficeDocState {
  tabsAdmissionsOffice: string;
  taskId: string;
  applicantId: number | null;
}

const initialState: AdmissionOfficeDocState = {
  tabsAdmissionsOffice: "",
  taskId: "",
  applicantId: null,
};

const admissionOfficeDocSlice = createSlice({
  name: "headerTabs",
  initialState,
  reducers: {
    setTabsAdmissionsOffice(state, action: PayloadAction<string>) {
      state.tabsAdmissionsOffice = action.payload;
    },
    setAdmissionFormContext(
      state,
      action: PayloadAction<Partial<{ taskId: string; applicantId: number | null }>>,
    ) {
      if (action.payload.taskId !== undefined) {
        state.taskId = action.payload.taskId;
      }
      if (action.payload.applicantId !== undefined) {
        state.applicantId = action.payload.applicantId;
      }
    },
    clearAdmissionFormContext(state) {
      state.taskId = "";
      state.applicantId = null;
    },
  },
});

export const { setTabsAdmissionsOffice, setAdmissionFormContext, clearAdmissionFormContext } =
  admissionOfficeDocSlice.actions;
export default admissionOfficeDocSlice.reducer;
